<template>
    <div>
        <v-chip
            v-if="formula && formula.length <= 17"
            outlined
            small
            label
            class="elevation-10"
        >
            <strong v-html="getFormula(formula)"></strong>
        </v-chip>
        <v-tooltip top v-else-if="formula && formula.length > 17">
            <template v-slot:activator="{ on, attrs }">
                <v-chip
                    outlined
                    small
                    label
                    v-bind="attrs"
                    v-on="on"
                    class="elevation-10"
                >
                    <strong>Préview</strong>
                </v-chip>
            </template>
            <span><strong v-html="formula"></strong></span>
        </v-tooltip>

    </div>
</template>

<script>
export default {
    name: "StrFormula",
    props: {
        formula: String
    },
    setup() {
        function getFormula(formula) {
            return formula
                .replace(/\//g, '<span class="operation">/</span>')
                .replace(/\(/g, '<span class="parentheses">(</span>')
                .replace(/\)/g, '<span class="parentheses">)</span>')
                .replace(/\+/g, '<span class="operation">+</span>')
                .replace(/\*/g, '<span class="operation">*</span>')
                .replace(/-/g, '<span class="operation">-</span>');
        }

        return {
            getFormula
        }
    }
}
</script>

<style>
.parentheses {
    color: green;
    font-weight: bold;
}

.operation {
    color: red;
    font-weight: bold;
}
</style>